import { render } from "micromustache";
import { PropertyConfig } from "../../../forms/propertyConfig";
import { ValidationError } from "../../../forms/validationError";
import { anyObject, getProp } from "../../../tools/any.tools";
import { anyReallyAny } from "../../../tools/object.tools";
import { ERROR_MESSAGES, FALLBACK_ERROR_MESSAGE } from "../validation.i18n";
import { RegisterValidator, Validator } from "./validator";
export const MAX_LENGTH_VALIDATOR_NAME = "maxLength";

/**
 * This validator ensures a string respects a maximum length
 * ! If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
 * sample use in propertyConfig => validators: validatorEntry(MaxLengthValidator, 15) or validators: { maxLength: 15 } (second option requires this class to be loaded)
 */
@RegisterValidator("maxLength")
export class MaxLengthValidator implements Validator<string, number> {


    /**
     * @returns true if propertyValue.length <= maxLength
     */
    public isValid(property: PropertyConfig, propertyValue: string, maxLength: number, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {
        if (propertyValue == null || propertyValue === "") {
            // If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
            return true;
        }
        return String(propertyValue).length <= maxLength;
    }

    /** Get error message of validator */
    public getError?(lang: string, property: PropertyConfig, propertyValue: anyReallyAny, validatorParams: number, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, anyReallyAny>): ValidationError {
        const errorMessage = getProp<anyObject>(ERROR_MESSAGES, lang)[MAX_LENGTH_VALIDATOR_NAME] ?? getProp<anyObject>(ERROR_MESSAGES, lang)[FALLBACK_ERROR_MESSAGE];
        return { errorMessage: render(errorMessage, { propLabel: property.label, validatorParams: validatorParams }) };

    }
}